import { SVGProps } from 'react';

export function LocumIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      {...props}
    >
      <circle cx="12" cy="6" r="4" fill="currentColor" fillOpacity="1" />
      <path
        d="M20 17.5c0 2.485 0 4.5-8 4.5s-8-2.015-8-4.5S7.582 13 12 13s8 2.015 8 4.5"
        fill="currentColor"
        fillOpacity="0.4"
      />

      {/* search icon in bottom-right */}
      <circle
        cx="17"
        cy="17"
        r="3"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
      <line
        x1="19"
        y1="19"
        x2="22"
        y2="22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
